import Link from '../../views/Link2requestorder';
import { connect } from 'react-redux';
import { actions } from '../../../state/assessment';
import { push } from 'connected-react-router';

const mapStateToProps = (state, ownProps) => ({
  intel: ownProps.match.params.intel,
  locale: ownProps.match.params.locale,
  reference_id: state.shift.assessment.reference_id,
  quotation_id: state.shift.assessment.quotation_id,
  po_num: state.shift.assessment.po_num
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;

  return {
    getQuotbypo: qoid => {
    
      //dispatch(actions.getQuotbypo(qoid));  no internal page used
      dispatch(actions.savequo(qoid));
     
    },

    gotopage: () => {
      
      // dispatch(push(`/${locale}/translatedcoderequest`));
      dispatch(push(`/${locale}/Link2approverequestpage`));
    }
  };
};

const Link2requestorder = connect(
  mapStateToProps,
  mapDispatchToProps
)(Link);

export default Link2requestorder;



// WEBPACK FOOTER //
// ./src/components/container/Link2requestorder/index.js